"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AuthenticatedContext = void 0;
exports.AuthenticationProvider = AuthenticationProvider;
exports.useAuthenticatedContext = useAuthenticatedContext;
exports.useChangePassword = useChangePassword;
exports.useLoginContext = useLoginContext;
exports.usePermission = usePermission;
var _react = _interopRequireWildcard(require("react"));
var _useClient = _interopRequireDefault(require("./useClient"));
var _KirokuAPIError = _interopRequireDefault(require("./KirokuAPIError"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var AuthenticatedContext = exports.AuthenticatedContext = /*#__PURE__*/_react.default.createContext({});
function AuthenticationProvider(_ref) {
  var storage = _ref.storage,
    renderUnAuthenticated = _ref.renderUnAuthenticated,
    children = _ref.children,
    _ref$renderAuthentica = _ref.renderAuthenticating,
    renderAuthenticating = _ref$renderAuthentica === void 0 ? function () {
      return null;
    } : _ref$renderAuthentica,
    _ref$onLogout = _ref.onLogout,
    onLogout = _ref$onLogout === void 0 ? function () {
      return null;
    } : _ref$onLogout;
  var client = (0, _useClient.default)();
  var Provider = AuthenticatedContext.Provider;
  var credential = storage.getItem('token');
  var _useState = (0, _react.useState)({
      authenticating: true,
      user: null,
      error: null
    }),
    _useState2 = _slicedToArray(_useState, 2),
    _useState2$ = _useState2[0],
    user = _useState2$.user,
    authenticating = _useState2$.authenticating,
    error = _useState2$.error,
    updateState = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    loginSuccess = _useState4[0],
    setLoginSuccess = _useState4[1];
  var logout = (0, _react.useCallback)(function () {
    storage.removeItem('token');
    onLogout(user);
    updateState({
      authenticating: false,
      user: null,
      error: null
    });
    setLoginSuccess(false);
  }, [storage, user, onLogout]);
  var updateProfile = (0, _react.useCallback)(function (user) {
    updateState({
      authenticating: authenticating,
      user: user,
      error: error
    });
  }, [authenticating, error, updateState]);
  (0, _react.useEffect)(function () {
    if (!credential) {
      updateState({
        authenticating: false,
        user: null,
        error: new _KirokuAPIError.default('User is un-authenticated')
      });
      setLoginSuccess(false);
    } else {
      client.axios.defaults.headers.common['Authorization'] = "".concat(credential);
      updateState({
        authenticating: true,
        user: null,
        error: null
      });
      client.axios.get('/users/me').then(function (user) {
        updateState({
          authenticating: false,
          user: user,
          error: null
        });
        setLoginSuccess(true);
      }).catch(function (error) {
        console.log(error, 'get Profile');
        localStorage.removeItem('token');
        updateState({
          authenticating: false,
          user: null,
          error: error
        });
        setLoginSuccess(false);
      });
    }
  }, [credential, client]);
  if (authenticating) {
    return renderAuthenticating();
  } else if (error) {
    return renderUnAuthenticated(error);
  } else {
    return /*#__PURE__*/_react.default.createElement(Provider, {
      value: {
        user: user,
        logout: logout,
        updateProfile: updateProfile,
        loginSuccess: loginSuccess
      }
    }, children);
  }
}
function useAuthenticatedContext() {
  return (0, _react.useContext)(AuthenticatedContext);
}
function usePermission() {
  var _useAuthenticatedCont = useAuthenticatedContext(),
    user = _useAuthenticatedCont.user;
  var isAdmin = user.role === 'admin';
  var isLeader = user.role === 'leader';
  return {
    isAdmin: isAdmin,
    isLeader: isLeader
  };
}
function useLoginContext(storage) {
  var client = (0, _useClient.default)();
  var _useState5 = (0, _react.useState)({
      token: storage.getItem('token'),
      isLoggingIn: false,
      error: null
    }),
    _useState6 = _slicedToArray(_useState5, 2),
    _useState6$ = _useState6[0],
    token = _useState6$.token,
    isLoggingIn = _useState6$.isLoggingIn,
    error = _useState6$.error,
    updateLoginState = _useState6[1];
  var _useState7 = (0, _react.useState)(false),
    _useState8 = _slicedToArray(_useState7, 2),
    nextStepOTP = _useState8[0],
    setNextStepOTP = _useState8[1];
  var login = (0, _react.useCallback)(function (username, password, otp) {
    updateLoginState({
      token: null,
      isLoggingIn: true,
      error: null
    });
    return client.axios.post('/login', {
      username: username,
      password: password,
      otp: otp
    }).then(function (res) {
      if (res.code === 'KIROKU_SUCCESS' && res.token) {
        storage.setItem('token', res.token);
        updateLoginState({
          token: res.token,
          isLoggingIn: false,
          error: null
        });
      }
      if (res.code === 'KIROKU_UNAUTH_INCORRECT_OTP' && res.message === 'Please enter the Auth Code') {
        updateLoginState({
          token: null,
          isLoggingIn: false,
          error: null
        });
        setNextStepOTP(true);
      }
      return res;
    }).catch(function (error) {
      updateLoginState({
        token: null,
        isLoggingIn: false,
        error: error
      });
      if (!['KIROKU_UNAUTH_INCORRECT_OTP_FAIL', 'KIROKU_UNAUTH_INCORRECT_PASSWORD', 'KIROKU_UNAUTH_INCORRECT_USERNAME'.includes(error.code)]) {
        return Promise.reject(error);
      }
    });
  }, [client, storage]);
  return {
    token: token,
    error: error,
    isLoggingIn: isLoggingIn,
    login: login,
    nextStepOTP: nextStepOTP
  };
}
function useChangePassword() {
  var client = (0, _useClient.default)();
  var _useState9 = (0, _react.useState)(null),
    _useState10 = _slicedToArray(_useState9, 2),
    result = _useState10[0],
    setResult = _useState10[1];
  var _useState11 = (0, _react.useState)(null),
    _useState12 = _slicedToArray(_useState11, 2),
    error = _useState12[0],
    setError = _useState12[1];
  var _useState13 = (0, _react.useState)(false),
    _useState14 = _slicedToArray(_useState13, 2),
    isLoading = _useState14[0],
    setLoading = _useState14[1];
  var changePassword = (0, _react.useCallback)(function (userId, dateBeUpdate) {
    setLoading(true);
    return client.axios.patch("/change-password/".concat(userId), dateBeUpdate).then(function (res) {
      setResult(res);
      setLoading(false);
      return res;
    }).catch(function (err) {
      setLoading(false);
      setError(err);
      return Promise.reject(err);
    });
  }, [client]);
  return [result, changePassword, isLoading, error];
}